import * as AT from '../constants/actionTypes'

/**
 * GDPR consent reducer
 * @param {*} state 
 * @param {*} action 
 */
function consent(state = { actual: {} }, action) {
	switch (action.type) {
		case AT.GDPR_CONSENT_BY_LICENSE_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				actual: {},
				error: undefined
			})
		case AT.GDPR_CONSENT_BY_LICENSE_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.GDPR_CONSENT_BY_LICENSE_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				actual: action.payload.consent,
				error: undefined
			})
		case AT.GDPR_CONSENT_BY_LICENSE_SAVING_STARTED:
			return Object.assign({}, state, {
				isSaving: true,
				error: undefined
			})
		case AT.GDPR_CONSENT_BY_LICENSE_SAVING_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.GDPR_CONSENT_BY_LICENSE_SAVING_FINISHED:
			return Object.assign({}, state, {
				isSaving: false,
				error: undefined,
				actual: { ...state, consentStatus: action.payload.newConsent.status }
			})						
		default:
			return state;
	}
}

export default consent;